module.exports = __webpack_public_path__ + "static/primary-coaches-sm-6d658a02d35300fe7ed2fff058781bad.webp";